import { paths } from '@/app/routes/paths';
import type { SessionUser } from '@/store/auth-store';
import { isGuardianPortalOnly, isStaffPortalMember } from '@/store/auth-store';

/** Guardians invited only to the portal skip org onboarding and land on participant hub. */
export function skipsOrganisationOnboarding(user: SessionUser): boolean {
  return isGuardianPortalOnly(user);
}

export function resolveDefaultHomePath(user: SessionUser): string {
  if (isStaffPortalMember(user)) {
    return paths.dashboard;
  }
  if (isGuardianPortalOnly(user)) {
    return paths.guardianDashboard;
  }
  return paths.dashboard;
}
